import { Box, Popover } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getAllTrip } from "../../api/trip";
import CloseIcon from "../../assets/SVG/closeIcon";
import LevelOnePop from "../../components/leaderGroup/levelOnePop";
import LevelTwoPop from "../../components/leaderGroup/levelTwoPop";
import ShowLevelPop from "../../components/leaderGroup/showLevelPop";

export default function CreateTripPop({
  anchorEl,
  setAnchorEl,
  dataSelected,
  dataGroup,
  dataDef,
  setDataTrips,
}) {
  const [level, setLevel] = useState(1);
  const [tripName, setTripName] = useState();
  const [date, setDate] = useState();
  const [clockTrip, setClockTrip] = useState();
  const [clockTripEnd, setClockTripEnd] = useState();
  const [countTrip, setCountTrip] = useState();
  const [trip, setTrip] = useState([
    {
      name: "string",
      owner: "string",
      color: "RED",
    },
  ]);
  const [colorData, setColorData] = useState({
    color: "white",
    name: "سفید",
    enum: "WHITE",
  });
  // console.log(dataDef);
  useEffect(() => {
    if (countTrip) {
      let trp = [];
      for (let i = 0; i < Number(countTrip); i++) {
        trp.push({
          name: "",
          // owner: "",
          color: "BLACK",
        });
      }
      setTrip(trp);
    }
  }, [countTrip]);

  useEffect(() => {
    if (dataDef) {
      setTripName(dataDef.name);
      const datePart = dataDef.startAt?.split(" - ")[0];
      const datePartEnd = dataDef.endAt?.split(" - ")[0];

      // تجزیه سال، ماه و روز
      const [year, month, day] = datePart.split("/");
      const [yearEnd, monthEnd, dayEnd] = datePartEnd.split("/");

      // ساختن آرایه‌ای با دو آبجکت
      const dateDef = [
        { year: year, month: month, day: day },
        { year: yearEnd, month: monthEnd, day: dayEnd },
      ];
      setDate(dateDef);
      setClockTrip(
        dataDef.startAt?.split("-", 3)[1] + dataDef.endAt?.split("-", 3)[1]
      );
      setCountTrip(dataDef.areas?.length);
    }
  }, [dataDef]);

  const handleClose = () => {
    setAnchorEl(null);
    setLevel(1);
    getAllTrip()
      .then((x) => {
        setDataTrips(x);
      })
      .catch(() => {});
    // setOpenPopover(false);
    // setDate();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <>
      <Popover
        sx={{
          "& .MuiPaper-root": {
            width: "750px",
            height: "auto",
            padding: "22px 23px",
            borderRadius: "13px",
          },
          "& .MuiBackdrop-root": {
            backgroundColor: "#00000060",
          },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box>
          <Box
            width="fit-content"
            sx={{ cursor: "pointer" }}
            onClick={handleClose}
          >
            {" "}
            <CloseIcon />{" "}
          </Box>
          <Box display="flex" gap="30px" alignItems={"center"}>
            <Box width="70%" height="300px">
              {level === 1 && (
                <LevelOnePop
                  level={level}
                  setLevel={setLevel}
                  tripName={tripName}
                  setTripName={setTripName}
                  date={date}
                  setDate={setDate}
                  clockTrip={clockTrip}
                  setClockTrip={setClockTrip}
                  countTrip={countTrip}
                  setCountTrip={setCountTrip}
                  dataSelected={dataSelected}
                  dataDef={dataDef}
                />
              )}
              {level === 2 && (
                <LevelTwoPop
                  dataSelected={dataSelected}
                  colorData={colorData}
                  setColorData={setColorData}
                  trip={trip}
                  setTrip={setTrip}
                  dataGroup={dataGroup}
                  level={level}
                  setLevel={setLevel}
                  dataDef={dataDef}
                  countTrip={countTrip}
                  setCountTrip={setCountTrip}
                  handleClose={handleClose}
                />
              )}
            </Box>
            <Box width="30%">
              <ShowLevelPop level={level} />
            </Box>
          </Box>
        </Box>
      </Popover>
    </>
  );
}
